import React from "react";
import { Chip, Tooltip } from "@mui/material";

/**
 * One counter of a viewer's header row.
 *
 * Counters describe the whole scope - the job, the task, the file - and never the
 * rows currently on screen, so a zero here means there is nothing of that kind at
 * all. Colour is spent only on a counter that is not zero.
 */
export default function CountChip({
  label,
  value,
  color,
  tooltip,
}: {
  label: string;
  value: number;
  color?: "success" | "error" | "warning" | "default";
  tooltip?: string;
}) {
  const chip = (
    <Chip
      size="small"
      variant="outlined"
      color={value > 0 ? color ?? "default" : "default"}
      label={`${label} ${value}`}
      sx={{ height: 22, fontSize: "0.7rem" }}
    />
  );
  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
}
